import React from 'react';
import {
  FiFileText,
  FiMail,
  FiMousePointer
} from 'react-icons/fi';

// Type casting for icons
const FiMailComponent = FiMail as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiMousePointerComponent =
  FiMousePointer as unknown as React.ComponentType<{
    size?: number | string;
    className?: string;
  }>;
const FiFileTextComponent = FiFileText as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

interface RecipientProfileProps {
  recipient: any;
}

// Component to display recipient profile information
const RecipientProfile: React.FC<RecipientProfileProps> = ({ recipient }) => {
  return (
    <div>
      {/* Profile Header */}
      <div className='bg-white rounded-lg border border-gray-200 shadow-sm p-6'>
        <div className='flex items-center gap-4'>
          <div className='w-12 h-12 rounded-full bg-purple-200 flex items-center justify-center text-xl font-bold text-purple-700'>
            {recipient.name[0]}
          </div>
          <div>
            <h3 className='text-[18px] font-semibold text-[#3F5265]'>
              {recipient.name}
            </h3>
            <p className='text-[#657584] text-[14px]'>
              <span className='mr-2'>{recipient.email}</span> |{' '}
              <span className='ml-2 mr-2'>{'30'}</span> |{' '}
              <span className='ml-2 mr-2'>{recipient.gender}</span> |{' '}
              <span className='ml-2 mr-2'>{'Kurla'}</span> |{' '}
              <span className='ml-2 mr-2'>{'Mumbai'}</span>
            </p>
          </div>
        </div>
        <hr className='my-6 border-t' />

        {/* Meta info row */}
        <div className='grid grid-cols-5 gap-4 mt-6 text-center items-center'>
          <span className='flex items-center mr-2 border-r-2 border-[grey]'>
            <p className='text-xs text-gray-500'>JOINED DATE</p>
            <p className='font-normal ml-4'>
              {recipient.joinedDate || '20-07-2025'}
            </p>
          </span>
          <span className='flex items-center ml-2 mr-2 border-r-2 border-[grey]'>
            <p className='text-xs text-gray-500'>LAST CLICKED</p>
            <p className='font-normal ml-4'>{recipient.lastClicked || '-'}</p>
          </span>
          <span className='flex items-center ml-2 mr-2 border-r-2 border-[grey]'>
            <p className='text-xs text-gray-500'>LAST OPENED</p>
            <p className='font-normal ml-4'>{recipient.lastOpened || '-'}</p>
          </span>
          <span className='flex items-center ml-2 mr-2'>
            <p className='text-xs text-gray-500'>STATUS</p>
            <span className='px-2 py-1 text-xs rounded-full bg-green-100 text-green-700 ml-4'>
              {recipient.status || 'Active'}
            </span>
          </span>
        </div>
      </div>

      {/* Stats Grid */}
      <div className='grid grid-cols-3 gap-2 mt-6'>
        <div className='bg-white rounded-md p-4 flex items-center justify-between border border-gray-200 shadow-sm'>
          <div>
            <h3
              className='text-gray-500 text-sm mb-2 font-semibold'
              style={{ color: '#657584', fontSize: '14px' }}
            >
              Sent Mails
            </h3>
            <p
              className='text-2xl mb-3'
              style={{ color: '#3F5265', fontSize: '28px' }}
            >
              {recipient.sentMails || 500}
            </p>
          </div>
          <div style={{ height: '-webkit-fill-available' }}>
            <span
              className='flex items-center justify-center mr-2'
              style={{
                width: '30px',
                height: '30px',
                backgroundColor: '#ECFDF5',
                borderRadius: '5px',
              }}
            >
              <FiMousePointerComponent
                className='text-green-500 text-2xl'
                size={17}
              />
            </span>
          </div>
        </div>
        <div className='bg-white rounded-md p-4 flex items-center justify-between border border-gray-200 shadow-sm'>
          <div>
            <h3
              className='text-gray-500 text-sm mb-2 font-semibold'
              style={{ color: '#657584', fontSize: '14px' }}
            >
              Delivered
            </h3>
            <p
              className='text-2xl mb-3'
              style={{ color: '#3F5265', fontSize: '28px' }}
            >
              {recipient.delivered || 400}
            </p>
          </div>
          <div style={{ height: '-webkit-fill-available' }}>
            <span
              className='flex items-center justify-center mr-2'
              style={{
                width: '30px',
                height: '30px',
                backgroundColor: '#E0F8FB',
                borderRadius: '5px',
              }}
            >
              <FiFileTextComponent
                className='text-teal-500 text-2xl'
                size={17}
              />
            </span>
          </div>
        </div>
        <div className='bg-white rounded-md p-4 flex items-center justify-between border border-gray-200 shadow-sm'>
          <div>
            <h3
              className='text-gray-500 text-sm mb-2 font-semibold'
              style={{ color: '#657584', fontSize: '14px' }}
            >
              Bounced
            </h3>
            <p
              className='text-2xl mb-3'
              style={{ color: '#3F5265', fontSize: '28px' }}
            >
              {recipient.bounced || 10}
            </p>
          </div>
          <div style={{ height: '-webkit-fill-available' }}>
            <span
              className='flex items-center justify-center mr-2'
              style={{
                width: '30px',
                height: '30px',
                backgroundColor: '#FFF1EC',
                borderRadius: '5px',
              }}
            >
              <FiMailComponent className='text-orange-500 text-2xl' size={17} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipientProfile;
